import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { productGroupsLoad } from 'portal/store/productGroups/actions'

export const useProductGroupsLoader = (overWriteProjectId = undefined) => {
  const dispatch = useDispatch()
  const { accountId, projectId: paramProjectId } = useModuleIds()

  const projectId = overWriteProjectId || paramProjectId

  const { loading, error, data } = useSelector((state: any) => {
    return state.productGroups
  })

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(productGroupsLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    // Avoid re-fetching if product groups are already loaded or loading
    if (Array.isArray(data) || loading) {
      return
    }
    reload()
  }, [data, loading, reload])

  return {
    loading,
    error,
    items: data,
    reload
  }
}
